import round from "./round.filter";

const roundModule = angular
  .module("app.filters.round", [])
  .filter("round", round);

export default roundModule;



// WEBPACK FOOTER //
// ./src/filters/round/round.module.js